export class IncidentHistoryFakeDb {
  public static histories = [];
}
